import { EventEmitter} from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';

import 'rxjs/add/observable/of';
import 'rxjs/add/observable/merge';


import {merge} from 'rxjs/observable/merge';
import {of as observableOf} from 'rxjs/observable/of';
import {catchError} from 'rxjs/operators/catchError';
import {map} from 'rxjs/operators/map';
import {startWith} from 'rxjs/operators/startWith';
import {switchMap} from 'rxjs/operators/switchMap';


export interface MatTableCustomApi<M> {
  items: M[];
  total_count: number;
  pageSize: number;
}

export interface MatTableCustomService<M> {
  search(any): Observable<MatTableCustomApi<M>>;
  selected: any;
}

export interface MatTableCustomDaoInterface<A, M> {
  getItems(sort: MatSort, page: number, pageSize: number, filter: string): Observable<MatTableCustomApi<M>>;
}

export class MatTableCustomDao<M> implements MatTableCustomDaoInterface<MatTableCustomApi<M>, M>{

  constructor(private service: MatTableCustomService<M>) { }

  getItems(s: MatSort, page: number, pageSize: number, filter: string): Observable<MatTableCustomApi<M>> {
    // console.log('================= getItems');
    // console.log('sort: ', s);
    // console.log('page: ', page + 1);
    // console.log('filter: ', filter);

    this.service.selected = undefined;

    let sortMap;
    if (s.active) {
      sortMap = {};
      sortMap[s.active] = s.direction == 'asc' ? 1 : -1;
    }

    let opt = {
      pageNumber: page + 1,
      pageSize: pageSize,
      sort: sortMap,
      filter: filter
    }

    return this.service.search(opt).map(response => response as MatTableCustomApi<M>);
  }
}

export class MatTableCustomDataSource<M, A> extends MatTableDataSource<M> {
  public resultsLength = 0;
  public resultsPageSize = 0;
  isLoadingResults: boolean = true;
  query: string;

  constructor(
    private dao: MatTableCustomDaoInterface<A, M>,
    private p: MatPaginator,
    private s: MatSort,
    private f: EventEmitter<String>,
    private split4detail: boolean) {
    super();

    const displayDataChanges = [
      s.sortChange,
      p.page,
      f
    ];
    s.sortChange.subscribe(() => {
      // console.log('sort subscribe!');
      p.pageIndex = 0
    });
    f.subscribe(f => {
      // console.log('filter subscribe!', f);
      this.query = f;
      p.pageIndex = 0;
    });

    merge(...displayDataChanges)
      .pipe(
      startWith({}),
      switchMap(() => {
        // console.log(s)
        // console.log(this.sa)
        this.isLoadingResults = true;
        return this.dao.getItems(
          s,
          p.pageIndex,
          p.pageSize,
          this.query);
      }),
      map(data => {
        this.isLoadingResults = false;
        this.resultsLength = data.total_count;
        this.resultsPageSize = data.pageSize;

        if (split4detail) {
          const rows = [];
          data.items.forEach(element => rows.push(element, { detailRow: true, element }));
          return rows;
        } else {
          return data.items;
        }
      }),
      catchError(() => {
        this.isLoadingResults = false;
        return observableOf([]);
      })
      ).subscribe(data => this.data = data);
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/mat-table-datasource.ts